import { render, staticRenderFns } from "./PsReports.vue?vue&type=template&id=41209d1c&scoped=true&"
import script from "./PsReports.vue?vue&type=script&lang=js&"
export * from "./PsReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41209d1c",
  null
  
)

export default component.exports